/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { EyeOpen } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';
import { ACTION, LeafTag, PrimaryTag, RootTag } from '../constants';
import { getReadableTimeStamp } from '../../../../../utils/UtilFunctions';
import { rowStyles } from '../../DelayDiallers/constants';
import Button from '../../../../../components/ComponentsV1/Button';

const getHeaders = (action) => {
  if (action === ACTION.VIEW) {
    return [
      { key: 'category_name', name: 'Category Name', width: '40%' },
      { key: 'updated_by', name: 'Updated By', width: '25%' },
      { key: 'updated_timestamp', name: 'Updated At', width: '20%' },
      { key: 'tags', name: 'Tags', width: '20%' },
      { key: 'actions', name: 'Actions', width: '10%' },
    ];
  } else if (action === ACTION.REVIEW) {
    return [
      { key: 'category_name', name: 'Category Name', width: '40%' },
      { key: 'tags', name: 'Tags', width: '20%' },
      { key: 'actions', name: 'Actions', width: '10%' },
    ];
  }
};

const TaskComponent = ({ tasks, action, title }) => {
  return (
    <div className='tw-flex tw-flex-col tw-border tw-border-solid tw-border-grey-200 tw-rounded-xl'>
      <span className='tw-text-zinc-500  tw-font-medium tw-text-400 tw-leading-none tw-bg-grey-100 tw-rounded-t-xl tw-p-5 tw-border tw-border-solid tw-border-grey-200 !tw-border-x-0 !tw-border-t-0 '>
        {title}
      </span>
      <div
        className={`tw-flex tw-items-center tw-w-full ${
          tasks?.length == 0 ? '' : 'tw-rounded-b-xl tw-bg-grey-100/70 '
        } tw-overflow-x-auto`}
      >
        <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
          <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
            {tasks?.length ? (
              <thead className='tw-rounded-xl'>
                <tr className='tw-rounded-2xl'>
                  {getHeaders(action?.title)?.map((heading, index) => (
                    <th
                      key={heading?.key}
                      title={heading?.name}
                      className={`tw-p-3 tw-bg-blue-200 tw-text-grey-800 ${
                        index === getHeaders(action?.title).length - 1
                          ? 'tw-border-r-0'
                          : 'tw-border-r'
                      } tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-overflow-hidden tw-text-ellipsis tw-leading-snug tw-text-center tw-w-[${
                        heading.width
                      }]`}
                    >
                      <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                        {heading?.name}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
            ) : null}
            {tasks?.length == 0 ? (
              <div className='tw-w-full tw-items-center tw-justify-center tw-text-grey-700 tw-text-400 tw-p-8 tw-font-medium '>
                No Pending Tasks.
              </div>
            ) : (
              <tbody className='tw-bg-white'>
                {action.title === ACTION.VIEW &&
                  tasks?.map((task, index) => {
                    if (!task) return null;
                    return (
                      <tr
                        key={`${task.category_name}-${index}`}
                        className={
                          index === tasks.length - 1
                            ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                            : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                        }
                      >
                        <td
                          className={`
                tw-py-4 tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-cursor-pointer tw-relative tw-group tw-leading-snug ${
                  index === tasks.length - 1 ? 'tw-rounded-bl-xl' : ''
                }
                `}
                        >
                          {task.category_name}
                        </td>
                        <td
                          className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[1rem] tw-leading-snug '
                          data-dd-privacy='mask'
                        >
                          {action.title == 'View' ? task.updated_by : '-'}
                        </td>
                        <td className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[1rem] tw-leading-snug '>
                          {action.title == 'View'
                            ? getReadableTimeStamp(task.updated_ts)
                            : '-'}
                        </td>
                        <td
                          className={`${rowStyles} tw-whitespace-nowrap tw-leading-snug `}
                        >
                          <span className='tw-flex tw-gap-2 tw-w-full tw-items-center tw-justify-center'>
                            {task.is_root ? <RootTag /> : null}
                            {task.is_leaf ? <LeafTag /> : null}
                            {task.is_primary ? <PrimaryTag /> : null}
                          </span>
                        </td>
                        <td
                          className={
                            index === tasks.length - 1
                              ? 'tw-rounded-br-2xl tw-border-none tw-px-2 tw-py-4'
                              : 'tw-px-2 tw-py-4'
                          }
                        >
                          {action.title == 'View' ? (
                            <div className='tw-w-full tw-flex tw-justify-center'>
                              <Button
                                type='icon'
                                title={<EyeOpen size={18} color={green.z700} />}
                                loading={
                                  action.isLoading && action.taskId == task.id
                                }
                                onClick={() => {
                                  action.handler(
                                    task.category_id,
                                    task.id,
                                    true,
                                  );
                                }}
                              />
                            </div>
                          ) : (
                            <span
                              className='tw-text-white tw-font-medium tw-bg-green-700 tw-rounded-xl tw-px-4 tw-py-2 tw-text-300 tw-cursor-pointer'
                              onClick={() => {
                                action.handler(
                                  task.category_id,
                                  task.id,
                                  false,
                                );
                              }}
                            >
                              {action.isLoading && action.taskId == task.id
                                ? 'Loading...'
                                : action.title}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                {action.title === ACTION.REVIEW &&
                  tasks?.map((task, index) => {
                    if (!task) return null;
                    return (
                      <tr
                        key={`${task.category_name}-${index}`}
                        className={
                          index === tasks.length - 1
                            ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                            : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                        }
                      >
                        <td
                          className={`
                tw-py-4 tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-cursor-pointer tw-relative tw-group tw-leading-snug ${
                  index === tasks.length - 1 ? 'tw-rounded-bl-xl' : ''
                }
                `}
                        >
                          {task.category_name}
                        </td>
                        <td
                          className={`${rowStyles} tw-whitespace-nowrap tw-leading-snug `}
                        >
                          <span className='tw-flex tw-gap-2 tw-w-full tw-items-center tw-justify-center'>
                            {task.is_root ? <RootTag /> : null}
                            {task.is_leaf ? <LeafTag /> : null}
                            {task.is_primary ? <PrimaryTag /> : null}
                          </span>
                        </td>
                        <td
                          className={
                            index === tasks.length - 1
                              ? 'tw-rounded-br-2xl tw-border-none tw-px-2 tw-py-4'
                              : 'tw-px-2 tw-py-4'
                          }
                        >
                          {action.title == 'View' ? (
                            <div className='tw-w-full tw-flex tw-justify-center'>
                              <Button
                                type='icon'
                                title={<EyeOpen size={18} color={green.z700} />}
                                loading={
                                  action.isLoading && action.taskId == task.id
                                }
                                onClick={() => {
                                  action.handler(
                                    task.category_id,
                                    task.id,
                                    true,
                                  );
                                }}
                              />
                            </div>
                          ) : (
                            <span
                              className='tw-text-white tw-font-medium tw-bg-green-700 tw-rounded-xl tw-px-4 tw-py-2 tw-text-300 tw-cursor-pointer'
                              onClick={() => {
                                action.handler(
                                  task.category_id,
                                  task.id,
                                  false,
                                );
                              }}
                            >
                              {action.isLoading && action.taskId == task.id
                                ? 'Loading...'
                                : action.title}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

export default TaskComponent;
